import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import ViewDansFundQuestionnaire from '../../../../components/Global/DansFundQuestionnaire/View';

// GraphQL query to fetch a specific questionnaire
const GET_QUESTIONNAIRE = gql`
  query GetQuestionnaire($id: uuid!) {
    dans_fund_questionnaire_by_pk(id: $id) {
      id
      name
      questions
    }
  }
`;

const AdminViewDansFundQuestionnaire = (): React.ReactElement => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const { data, loading, error } = useQuery(GET_QUESTIONNAIRE, {
    variables: { id },
    fetchPolicy: 'no-cache',
  });

  const handleEdit = () => {
    navigate(`/admin/dans-fund-questionnaire/${id}/edit`);
  };

  const handleBack = () => {
    navigate('/admin/dans-fund-questionnaire');
  };

  return (
    <DashboardLayout 
      title={`View Questionnaire: ${data?.dans_fund_questionnaire_by_pk?.name || 'Loading...'}`}
      // @ts-ignore - DashboardLayout has different props in this project
      handleBackClick={handleBack}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ textAlign: 'right', marginBottom: '16px' }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<EditIcon />}
            onClick={handleEdit}
          >
            Edit Questionnaire
          </Button>
        </Grid>
        <Grid item xs={12}>
          {loading ? (
            <div>Loading...</div>
          ) : error ? (
            <div>Error loading questionnaire</div>
          ) : (
            <ViewDansFundQuestionnaire questionnaireId={id} />
          )}
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default AdminViewDansFundQuestionnaire;
